import { NON_CALLABLE_HOOKS } from "../hooks";
import { applyQueries } from "../helpers";
// set is a reserved word in the language
export function setter(connectionName, store, onlyConnect, t, p, v // Proxy auto-passed params
) {
    if (p === NON_CALLABLE_HOOKS.query) {
        t[p] = v;
        applyQueries(store, connectionName, t, onlyConnect);
        return true;
    }
    return Reflect.set(t, p, v);
}
//# sourceMappingURL=setter.js.map